import { Dispatch, SetStateAction } from "react";

import { MultiSelect, useMultiSelect } from "chakra-multiselect";

import { keywordOptions } from "utils/topicsList";

interface KeywordsMultiselectProps {
    keywords: string[];
    setKeywords: Dispatch<SetStateAction<string[]>>;
}

export const KeywordsMultiselect = ({ keywords, setKeywords }
    : KeywordsMultiselectProps
) => {

    const { value, options, onChange } = useMultiSelect({
        value: keywords,
        options: keywordOptions,
    });
    const ALPHANUMERIC_AND_WHITESPACE_REGEX = /[^\w\s]/gi;
    const handleChange = (values, actionAndValues) => {
        // remove punctuation characters from input
        values = (values as string[]).map((v) =>
            v.replace(ALPHANUMERIC_AND_WHITESPACE_REGEX, "")
        );
        onChange && onChange(values, actionAndValues);
        // Todo fix this
        setKeywords(values as string[]);
    }

    const MULTI_SELECT_WIDTH = "500px"
    const MULTI_SELECT_HEIGHT = "60px"
    const multiSelectStyle = { height: MULTI_SELECT_HEIGHT, width: MULTI_SELECT_WIDTH }

    return (
        <MultiSelect
            style={multiSelectStyle}
            h={"12"}
            mt={2}
            options={options}
            {...{
                // select box
                // dropdown list
                controlProps: {
                    maxWidth: MULTI_SELECT_WIDTH,
                },
                listProps: {},
                // typed text
                selectedListProps: {
                    m: 2,
                },
                // dropdown icon box
                actionGroupProps: {
                    pr: 1,
                },
                value: keywords,
                onChange: handleChange,
            }}
            create
        />
    );
}